<template>
    <Teleport to="body">
        <div v-if="visible"
            class="fixed top-0 left-0 w-full h-full flex align-items-center justify-content-center bg-black-alpha-90"
            style="z-index: 9999;">
            <div class="text-center text-white p-5 w-30rem max-w-full">
                <div class="mb-4">
                    <i class="pi pi-spin pi-spinner text-primary text-6xl block mb-4"></i>
                    <div class="flex align-items-center justify-content-center gap-4 text-5xl mt-4">
                        <i :class="oldRoleIcon" class="text-400"></i>
                        <i class="pi pi-arrow-right text-primary"></i>
                        <i :class="newRoleIcon" class="text-primary"></i>
                    </div>
                </div>
                <div>
                    <h3 class="text-3xl font-bold mb-3 text-primary">Alternando Perfil</h3>
                    <p class="text-lg m-0 font-medium text-200">{{ message }}</p>
                </div>
            </div>
        </div>
    </Teleport>
</template>

<script setup lang="ts">
defineProps({
    visible: {
        type: Boolean,
        default: false,
    },
    oldRoleIcon: {
        type: String,
        default: "pi pi-user",
    },
    newRoleIcon: {
        type: String,
        default: "pi pi-user",
    },
    message: {
        type: String,
        default: "",
    },
});
</script>
